import React from 'react'
import { createRoot } from 'react-dom/client'

export const FORM_BUILDER_WIDGET_COMPONENT_NAME = 'formbuilder'
export const FORM_BUILDER_WIDGET_ELEMENT_SELECTOR = `div[data-component="${FORM_BUILDER_WIDGET_COMPONENT_NAME}"]`

document.querySelectorAll(FORM_BUILDER_WIDGET_ELEMENT_SELECTOR)
  .forEach(function (element) {
    Promise.all([
      import('schemaform/src/formbuilder'),
      import('schemaform/src/formcore/services/dataset-configuration'),
      import('schemaform/src/formcore/services/queryset-configuration'),
      import('../../services/config/ElementConfigService'),
      import('lodash/defaultsDeep'),
    ]).then(([{ default: FormBuilder }, { DatasetConfiguration }, { QuerysetConfiguration }, { ElementDatasetConfig }, { default: defaultsDeep }]) => {
      if (element instanceof HTMLDivElement) {
        const config = ElementDatasetConfig(element)
        const {
          component: name,
          ...attributes
        } = element.dataset
        const props = defaultsDeep(
          QuerysetConfiguration(window.location.search, name),
          DatasetConfiguration(attributes, name),
          config,
        )
        const Component = React.createElement(FormBuilder, props)
        const root = createRoot(element)
        root.render(Component)
      } else {
        console.log("Error: Formbuilder must be mounted through a <div> element")
      }
    }).catch((err) => console.error('FormBuilder load failed', err))
  })
